import { createSelector } from '@reduxjs/toolkit';
import { selectRentCommission } from 'shared/selectors/jsonQuery';

const OPTIONS = [
  { label: 'Неважно', value: null },
  { label: 'Без комиссии', value: 0 },
  { label: 'До 50%', value: 50 },
  { label: 'До 70%', value: 70 },
  { label: 'До 100%', value: 100 },
];

export const selectRentCommissionFilter = createSelector(selectRentCommission, ({ lte = null }) => ({
  label: 'Комиссия',
  options: OPTIONS,
  value: [lte],
}));
